import React, { FC } from 'react'
import { ExperimentEndPage } from 'Components/Shared/ExperimentEndPage/ExperimentEndPage'
import { selectBannerData } from 'redux/reducers/dataStore/dataStore.selectors'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { emptyBasket } from 'redux/reducers/logicStore/logicStore'

export const ExperimentEndScreen: FC = () => {
  const bannerData = useSelector(selectBannerData)
  const dispatch = useDispatch()
  const history = useHistory()

  const handleReset = () => {
    // Dispatch action to redux to reset store
    dispatch(emptyBasket())
    // Reset to the first page in the journey by dispatching the firstPage action
    history.push('/')
  }

  return (
    <ExperimentEndPage
      bannerName={bannerData.text}
      bannerLogoSrc={bannerData.logoSrc}
      onClickReset={handleReset}
    />
  )
}
